/**
 * WordPress dependencies
 */
import { compose } from '@wordpress/compose'
import { RichText } from '@wordpress/block-editor'
import { applyFilters } from '@wordpress/hooks'

/**
 * Internal dependencies
 */
import { name } from './index'
import { range } from '~cartzillagb/util'

/**
 * External dependencies
 */
import classnames from 'classnames'

const save = props => {
	const { 
		attributes, 
		className
	} = props 

	const {
		limit,
	} = attributes

	const mainClasses = classnames( [
		className,
		'czgb-market-button',
	], applyFilters( `cartzillagb.${ name.replace( 'czgb/', '' ) }.main-block.classes`, {}, props ) )

	const content = range( 1, ( limit ) + 1 ).map( i => {

		const PreTitle = attributes[ `pretitle${ i }` ]
		const Title = attributes[ `title${ i }` ]
		const bgColor = attributes[ `bgcolor${ i }` ]
		const bgcustomColor = attributes[ `bgcustomcolor${ i }` ]
		const icon = attributes[ `icon${ i }` ]
		const link = attributes[ `link${ i }` ] !== undefined ? attributes[ `link${ i }` ]  : '#'

		let defaulttitle = ''
		let defaultpretitle = ''
		let defaultIcon = ''

		if ( (i % 4 ) === 1 ) {
			defaultpretitle = "Download on the"
			defaulttitle = "App Store"
			defaultIcon = 'btn-apple'
		}

		if ( (i % 4 ) === 2 ) {
			defaultpretitle = "Download on the"
			defaulttitle = "Google Play"
			defaultIcon = 'btn-google'
		}

		if ( (i % 4 ) === 3 ) {
			defaultpretitle = "Download on the"
			defaulttitle = "Windows Store"
			defaultIcon = 'btn-windows'
		}

		if ( (i % 4 ) === 0 ) { 
			defaultpretitle = "Download on the"
			defaulttitle = "Amazon.com"
			defaultIcon = 'btn-amazon'
		}

		const bgstyle = { backgroundColor: bgcustomColor && bgcustomColor }

		const iconClass = classnames( [
			icon === 'none' && '',
			icon === 'btn-apple' && ' btn-apple',
			icon === 'btn-google' && ' btn-google',
			icon === 'btn-windows' && ' btn-windows',
			icon === 'btn-amazon' && ' btn-amazon'
		] )

		const pretitleComp =(
			<RichText.Content
				tagName="span"
				className="btn-market-subtitle"
				value={ PreTitle || defaultpretitle }
			/>
		)

		const titleComp =(
			<RichText.Content
				tagName="span"
				className="btn-market-title"
				value={ Title || defaulttitle }
			/>
		)

		const output = (
			<a className={ `btn-market ${ iconClass || defaultIcon } mr-3 mb-3 ${ bgColor ? bgColor : bgcustomColor ? '' : '' }` } style={ bgstyle } href={ link } role="button">
				{ pretitleComp }
				{ titleComp }
			</a>
		)
			
			return output
	}   )

	return (
		<div className={ mainClasses }>
			{ content }
		</div>
	)
}

export default compose(
)( save )